module.exports = __webpack_public_path__ + "static/media/Landscape-Alicante-mountains.edefcf61.jpg";